import { AsYouType, parsePhoneNumberFromString } from "libphonenumber-js";

const onlyDigits = (value) =>
  String(value || "")
    .normalize("NFKC")
    .replace(/\D/g, "");

export const formatContactPhoneInput = (value) => {
  const raw = String(value || "")
    .normalize("NFKC")
    .trim();
  if (!raw || /@lid$/i.test(raw)) return "";

  let digits = onlyDigits(raw);
  if (digits.startsWith("00")) digits = digits.slice(2);

  const isExplicitForeignNumber =
    raw.startsWith("+") && !digits.startsWith("55");
  if (isExplicitForeignNumber) {
    return new AsYouType().input(`+${digits.slice(0, 15)}`);
  }

  const national =
    raw.startsWith("+55") || (digits.startsWith("55") && digits.length > 11)
      ? digits.slice(2, 13)
      : digits.slice(0, 11);

  if (!national) return "";
  return `+55 ${new AsYouType("BR").input(national)}`;
};

export const normalizeContactPhoneForSubmit = (value) => {
  const raw = String(value || "")
    .normalize("NFKC")
    .trim();
  if (!raw || /@lid$/i.test(raw)) return "";

  let digits = onlyDigits(raw);
  if (digits.startsWith("00")) digits = digits.slice(2);

  const candidate =
    raw.startsWith("+") ||
    (digits.startsWith("55") && (digits.length === 12 || digits.length === 13))
      ? `+${digits}`
      : digits;
  const phone = parsePhoneNumberFromString(candidate, "BR");

  return phone && phone.isValid() ? phone.number.slice(1) : "";
};

export const isValidContactPhone = (value) =>
  Boolean(normalizeContactPhoneForSubmit(value));
